export class DayStatusModel {
    day: number;
    presentStatus: string;
    date? :string;
    hours?:string;

    /**
     * 
     * @param day 
     * @param presentStatus 
     * @param date
     */
    constructor(day: number, presentStatus: string, date:string,hours?:string){
        this.day = day;
        this.presentStatus = presentStatus;
        this.date=date
        this.hours=hours
    }
}